/**
 * Arranque React: AuthProvider > DataProvider > NavigationProvider > App.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './AuthContext';
import { DataProvider } from './DataContext';
import { NavigationProvider } from './NavigationContext';
import './mobile.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <DataProvider>
        <NavigationProvider>
          <App />
        </NavigationProvider>
      </DataProvider>
    </AuthProvider>
  </React.StrictMode>
);
